import { render } from "./SiteSeguro.vue?vue&type=template&id=4a8765ec"
import script from "./SiteSeguro.vue?vue&type=script&lang=js"
export * from "./SiteSeguro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__